<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section intro-section">
    <h2 class="section-title">Assurance Loyers Impayés</h2>
    <div class="intro-content">
      <p>
        Se protéger contre les impayés est votre principale préoccupation en tant que propriétaire. Pour ce faire, deux options : l'assurance loyers impayés ou la caution d'un garant. La meilleure solution à choisir, pour vous propriétaire, est la <strong class="text-purple">Garantie des Loyers Impayés</strong> : la plus sécurisée, pour vos revenus et pour votre bien immobilier.
      </p>
      <p>
        Aujourd'hui, le cumul de ces deux dispositifs est possible en cas de locataires étudiants ou apprentis.
      </p>
      <p>
        Votre locataire cesse de vous payer le loyer ?
      </p>
      <p>
        Votre locataire ne respecte pas son préavis ?
      </p>
      <p>
        Vous constatez des dégradations des lieux ?
      </p>
      <p>
        Alors souscrivez une assurance <strong class="text-purple">Garantie Loyers Impayées</strong> dite <strong class="text-purple">GLI</strong> pour éviter les mauvaises surprises.
      </p>
      <p>
        Si l'assurance des loyers impayés n'est pas obligatoire, l'assurance du bien immobilier en lui-même que l'on appelle <a href="/assurance-multirisque-immeuble-pno" class="link-purple">assurance Multirisque Immeuble – MRI – PNO</a> dite Assurance PNO est obligatoire.
      </p>
      
      <div class="cta-box">
        <a href="/contact" class="btn-devis">Devis en ligne</a>
      </div>
    </div>
  </div>

  <div class="content-section advice-section">
    <h3 class="section-subtitle">Avant de confier vos clés, assurez-vous de recevoir vos loyers !</h3>
    <p>La garantie des loyers impayés protège les propriétaires bailleurs des risques liés à l'locatif. Ces risques sont :</p>
    <ul class="advice-list">
      <li>Les loyers impayés,</li>
      <li>Les contentieux locatifs,</li>
      <li>Les dégradations immobilières,</li>
      <li>L'inoccupation suite à un départ furtif ou d'un préavis réduit,</li>
      <li>Le dépôt de garantie non réglé par le locataire.</li>
    </ul>
    <p>L'assureur peut également proposer une couverture juridique au propriétaire.</p>
    <p>La garantie loyers impayés peut couvrir, selon la formule retenue :</p>
    <ul class="advice-list">
      <li>Jusqu'à <strong class="highlight-purple">100 000 €</strong> de loyers impayés et contentieux locatif,</li>
      <li>Un maximum de <strong class="highlight-purple">15 000 €</strong> pour couvrir les dégradations immobilières garanties,</li>
      <li>Une protection juridique à hauteur de <strong class="highlight-purple">25 000 €</strong> pour tout litige lié à l'application du bail de la location garantie,</li>
      <li>La totalité des cotisations déductibles des revenus locatifs,</li>
      <li>Une marge de solvabilité des locataires portée jusqu'à <strong class="highlight-purple">40 %</strong>.</li>
    </ul>
    <p>
      Il n'y a généralement pas de franchise pour ce genre de contrat appliqué si un dépôt de garantie équivalent à la date du bail a été prévu.
    </p>
    <p>
      Pour pouvoir souscrire cette garantie, il est généralement nécessaire que le bail comporte une clause résolutoire en cas de non-paiement des loyers au terme convenu.
    </p>
  </div>

  <div class="content-section guarantees-section">
    <h3 class="section-subtitle">QUE COUVRENT CES GARANTIES ?</h3>
    
    <div class="guarantee-block">
      <h4>La Garantie des Loyers</h4>
      <p>Elle couvre les pertes pécuniaires subies par le propriétaire du fait :</p>
      <ul class="guarantee-list">
        <li>D'un locataire défaillant (non-paiement des loyers, charges et taxes prévues au bail) et ce, sans limitation de durée,</li>
        <li>Du non_respect ou du non_paiement du préavis, en cas de préavis réduit, de décès ou de départ prématuré du locataire sans respecter les délais,</li>
      </ul>
      <p>
        Les lots assurables sont généralement les baux d'habitation meublés ou non meublés, et les baux professionnels (comme les professions libérales par exemple). Les loyers mensuels maximums ne doivent pas dépasser <strong class="highlight-purple">5000€ Charges Comprises</strong>.
      </p>
    </div>

    <div class="guarantee-block">
      <h4>La Garantie des Contentieux</h4>
      <p>Elle couvre pour le recouvrement des impayés :</p>
      <ul class="guarantee-list">
        <li>Les frais de contentieux afférents aux honoraires d'avocats, d'avoués et d'huissier de justice,</li>
        <li>Les frais de procédure judiciaire,</li>
        <li>Les frais de procédure d'expulsion du locataire (serrurier, force publique…),</li>
        <li>Les frais de garde-meuble.</li>
      </ul>
    </div>

    <div class="guarantee-block">
      <h4>La Garantie des Détériorations Immobilières</h4>
      <p>Elle couvre le remboursement :</p>
      <ul class="guarantee-list">
        <li>Des frais de réparation consécutifs à toutes dégradations, destructions, altérations perpétrées par le locataire sur les biens immobiliers du propriétaire,</li>
        <li>Des dommages matériels consécutifs à la procédure d'expulsion,</li>
        <li>De la perte pécuniaire consécutive au temps matériel nécessaire à la remise en état des locaux.</li>
      </ul>
      <p>
        Pour cette garantie, un état des lieux est généralement obligatoire à l'entrée ou à la sortie.
      </p>
    </div>

    <div class="guarantee-block">
      <h4>La Garantie Protection Juridique</h4>
      <p>
        Le propriétaire est garanti pour tout conflit ayant son origine dans l'exécution du contrat de location des locaux assurables (en dehors des conflits déjà pris en charge par les garanties des loyers et des détériorations immobilières).
      </p>
    </div>

    <div class="guarantee-block">
      <h4>Le Tarif</h4>
      <p>Généralement, le tarif est adapté au profil du locataire (taux d'effort, CSP). Il commence très souvent à <strong class="highlight-purple">2% TTC</strong>.</p>
      <p>
        Mais le propriétaire peut déduire l'ensemble des primes de ses revenus locatifs, ce qui lui confère un avantage fiscal certain.
      </p>
    </div>

    <div class="guarantee-block">
      <h4>Les Exclusions fréquentes :</h4>
      <ul class="guarantee-list">
        <li>Les locations de biens situés hors de France métropolitaine,</li>
        <li>Les locations dont le loyer mensuel (dont les provisions pour charges et taxes locatives) est supérieur à <strong class="highlight-purple">5 000€ TTC</strong> à la date de souscription,</li>
        <li>Les logements faisant l'objet d'une sous-location avec ou sans l'accord du propriétaire,</li>
        <li>Les logements faisant l'objet d'un bail commercial, rural,</li>
        <li>Les logements faisant l'objet d'un bail verbal, précaire ou saisonnier ainsi que les résidences étudiantes,</li>
        <li>Les logements dont les baux portent sur des locaux de type HLM ou dont les baux sont soumis à la Loi de 1948,</li>
        <li>Les logements ne présentant pas les normes d'habitabilité fixées par la législation en vigueur,</li>
        <li>Les logements loués au personnel d'ambassades, de consulats et de consulats et aux diplomates en général.</li>
      </ul>
    </div>

    <div class="guarantee-block">
      <h4>Les Inconvénients à ne pas souscrire la Protection des Loyers Impayés :</h4>
      <ul class="guarantee-list">
        <li>Vous devez demander au garant d'assurer le paiement des loyers impayés. Sa fiabilité peut être remise en cause en cas de perte de revenus, perte d'emploi ou décès. Période pendant laquelle vous ne percevez aucun loyer,</li>
        <li>Vous n'avez aucune indemnité en cas de dégradations immobilières, autre que le dépôt de garantie, pour la remise en état du logement ni pour les pertes pécuniaires associées,</li>
        <li>Vous devez engager des frais pour poursuivre le locataire et son garant en cas d'impayés (frais d'huissier en supplément, entièrement à votre charge),</li>
        <li>Vous devez payer entièrement les frais liés à la procédure judiciaire (huissier, avocat, déménageur, serrurier),</li>
        <li>Vous gérez intégralement la procédure : rendez-vous avec l'avocat, avec l'huissier, suivi de la procédure, présentation d'un dossier à l'audience,</li>
        <li>Vous devez collecter et contrôler vous-même les dossiers des candidats locataires,</li>
        <li>Vous devez vous assurer de l'authenticité des documents fournis par le locataire et le garant,</li>
        <li>Vous devez effectuer toutes les démarches juridiques auprès du locataire et du garant pour percevoir les loyers dus.</li>
      </ul>
    </div>

    <p class="partner-info">
      Le courtier en Assurance BROKINS est partenaire de ces quelques assureurs assurance Garantie Loyers Impayés, dont un échantillon est affiché ci-dessous : <strong class="text-purple">INSURED SERVICES, EURODOMMAGES, SOLLY AZAR.</strong>
    </p>
  </div>

  <div class="content-section cta-bottom">
    <a href="/contact" class="btn-devis-bottom">Devis en ligne</a>
  </div>

</app-page-layout>
